<template>
  <div>
    <el-drawer
      :visible.sync="treeDrawer"
      direction="rtl"
      size="30%"
      @close="cancelForm"
    >
      <div class="top_select">
        <el-tree
          :props="defaultProps"
          :data="treeData"
          node-key="id"
          show-checkbox
          center
          ref="treeRef"
          :default-checked-keys="defaultCheckedNodes"
        >
        </el-tree>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="editPermit" :loading="loading">{{
            loading ? '提交中 ...' : '确 定'
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { updateRolePermitRoleApi } from '@/api/user.js';
// import { getToken } from '@/utils/token';
export default {
  props: ['roleId', 'menuObj'],
  inject: ['reload'],
  data() {
    return {
      permitData: {},
      treeDrawer: false,
      defaultProps: {
        children: 'childs',
        label: 'name',
      },
      loading: false,
      agentList: [],
      treeData: [],
      defaultCheckedNodes: [],
    };
  },
  mounted() {
    // this.$refs.treeRef.setCheckedNodes(this.defaultCheckedNodes)
  },
  methods: {
    cancelForm() {
      this.treeData = [];
      this.treeDrawer = false;
    },
    async editPermit() {
      //   const houseId = JSON.parse(getToken('userInfo')).houseId;
      this.loading = true;
      let allCheckedNodes = this.$refs.treeRef.getCheckedNodes();
      console.log(allCheckedNodes, '选中的数据');
      let allNodes = [];
      allCheckedNodes.forEach((item, index) => {
        if (item.houseId) {
          //   为楼盘id
          let data = {};
          let obj = {};
          data.name = item.name;
          data.houseId = item.houseId;
          data.roleId = this.roleId;
          while (allCheckedNodes[index++].houseId) {
            for (let i = 0; i < allCheckedNodes.length; i++) {
              if (!allCheckedNodes[i].childs) {
                //为叶子结点
                if (!obj[allCheckedNodes[i].menuId]) {
                  obj[allCheckedNodes[i].menuId] = [];
                }
                obj[allCheckedNodes[i].menuId].push(
                  allCheckedNodes[i].permitId
                );
              }
            }
            data.dctRolePermit = { ...this.menuObj, ...obj };
          }

          allNodes.push(data);
        }
      });
      //
      console.log(allNodes, 'lalala');
      const res = await updateRolePermitRoleApi(allNodes);
      this.loading = false;
      if (res.code === 200) {
        this.$message.success('修改成功');
        this.reload();
      }
    },
  },
};
</script>
<style lang="less">
.el-drawer__body {
  overflow: scroll;
}
.demo_drawer__footer {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
.top_select {
  margin-left: 30px;
  .select {
    width: 500px;
    margin-bottom: 30px;
  }
}
</style>